/** Nunito Sans isn't in the platform font registry, so it's loaded here. */
const NUNITO_SANS_URL =
  'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&display=swap';

export const HERO_FONT_CLASS = 'hero-font';

/** Render once per hero that uses HERO_FONT_CLASS. */
export function HeroFont() {
  return (
    <>
      <link rel="stylesheet" href={NUNITO_SANS_URL} />
      <style>{`.${HERO_FONT_CLASS} { font-family: 'Nunito Sans', sans-serif; }`}</style>
    </>
  );
}
